import { NET_POSITIONS, NET_POSITIONS_ERROR, NET_POSITIONS_HIDE_ERROR, NET_POSITIONS_START_LOADER, NET_POSITIONS_STOP_LOADER, } from "../interface/INetPositions";
const initState = {
    data: {
        data: {},
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const NetPositions = (state = initState, action) => {
    switch (action.type) {
        case NET_POSITIONS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case NET_POSITIONS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case NET_POSITIONS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case NET_POSITIONS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case NET_POSITIONS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default NetPositions;
